import { render } from "./FreightForwarderNav.vue?vue&type=template&id=04f7187a&scoped=true"
import script from "./FreightForwarderNav.vue?vue&type=script&lang=js"
export * from "./FreightForwarderNav.vue?vue&type=script&lang=js"

import "./FreightForwarderNav.vue?vue&type=style&index=0&id=04f7187a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f7187a"]])

export default __exports__